module.exports = __webpack_public_path__ + "media/images/icon__copy-to-clipboard@2x-688a2ab1fd40db3e93e5884dca7402a9.png";